<template>
  <fragment>
    <CardModule title="Imagens">
      <v-row>
        <v-col cols="6">
          <BaseSelect
            required
            label="Tipo de imagem"
            placeholder="Selecione o tipo de imagem"
            item-text="key"
            item-value="value"
            :items="filteredData"
            v-model="$produtos_gerenciar.cadastro.customizacao.imagem"
          />
        </v-col>
        <v-col cols="6">
          <v-file-input
            show-size
            accept="image/png, image/jpeg, image/bmp"
            solo
            placeholder="Clique aqui para importar a imagem"
            no-data-text="Todas imagens já foram incluídas."
            :hint="
              $produtos_gerenciar.cadastro.customizacao.imagem == 'destaque'
                ? 'A dimensão sugerida para esta imagem é 600x300 pixels e o tamanho máximo é de 2mb.'
                : 'A dimensão sugerida para esta imagem é 1080 x 1920 pixels e o tamanho máximo é de 2mb.'
            "
            :rules="rulesSize"
            ref="fileInputRef"
            persistent-hint
            clearable
            class="input-file-tema input-form"
            v-model="
              $produtos_gerenciar.cadastro.customizacao.imagem_upload.object
            "
            :prepend-icon="$config.icons.image"
            :clear-icon="$config.icons.clear"
            :append-outer-icon="
              $produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem
                ? $config.icons.view
                : ''
            "
            @click:append-outer="
              previewImage(
                $produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem
              )
            "
            @click:clear="clearImage()"
            @change="
              getImagem(
                $produtos_gerenciar.cadastro.customizacao.imagem_upload.object
              )
            "
            :error-messages="
              $produtos_gerenciar.cadastro.customizacao.error.imagem_upload
            "
            @input="
              $produtos_gerenciar.cadastro.customizacao.error.imagem_upload = []
            "
          >
          </v-file-input>
        </v-col>
      </v-row>
      <v-row class="justify-end mb-4">
        <v-col cols="6" class="d-flex flex-column">
          <v-btn
            :loading="$produtos_gerenciar.cadastro.customizacao.loading_imagem"
            @click="
              uploadImage(
                $produtos_gerenciar.cadastro.customizacao.imagem_upload.imagem
              )
            "
          >
            Fazer upload
            <v-icon>mdi-upload-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" class="mb-2">
        <v-col cols="12" class="d-flex justify-center" v-if="noHasData">
          <span>Não há registro de imagens para este produto.</span>
        </v-col>
        <v-simple-table fixed-header dense v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="(header, index) in headersImgs"
                  :key="index"
                  class="text-center"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(prodImg, index) in $produtos_gerenciar.cadastro
                  .customizacao.imagens_array"
                :key="index"
              >
                <td class="text-center">{{ Object.keys(prodImg)[0] }}</td>
                <td class="text-center">{{ Object.values(prodImg)[0] }}</td>
                <td class="table-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                        small
                        dark
                        icon
                        @click="previewImage(Object.values(prodImg)[0])"
                      >
                        <v-icon>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="grey darken-2"
                        v-bind="attrs"
                        v-on="on"
                        small
                        dark
                        icon
                        @click="
                          remover(
                            index,
                            Object.keys(prodImg)[0],
                            'Deseja realmente excluir esta imagem?'
                          )
                        "
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Deletar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </CardModule>
    <ModalVisualizarImagem :image="imagemModal" screen="produto" />
    <ModalConfirmacao :textModal="textModalConfirm" @callback="funcaoRemover" />
  </fragment>
</template>

<script>
import mixins from "@/mixins";
import CardModule from "@/components/cards/CardModule.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import ModalVisualizarImagem from "@/components/global/modal-visualizar-imagem.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";

const { products, formRules } = mixins;

export default {
  name: "Customization",
  components: {
    ModalVisualizarImagem,
    ModalConfirmacao,
    CardModule,
    BaseSelect,
  },
  mixins: [products, formRules],
  data() {
    return {
      rulesSize: [
        v =>
          !v ||
          v.size < 2000000 ||
          "A imagem deve ter o tamanho máximo de 2MB!",
      ],
    };
  },

  computed: {
    filteredData() {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME"
      ) {
        return this.tipo_imagem_iframe.filter(item => item.show === true);
      }
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
        return this.tipo_imagem_link.filter(item => item.show === true);
      }
      return this.tipo_imagem.filter(item => item.show === true);
    },
    noHasData() {
      return (
        this.$produtos_gerenciar.cadastro.customizacao &&
        this.$produtos_gerenciar.cadastro.customizacao.imagens_array &&
        this.$produtos_gerenciar.cadastro.customizacao.imagens_array.length == 0
      );
    },
    fileInputHint() {
      if (this.$produtos_gerenciar.cadastro.customizacao.imagem === "destaque")
        return "A dimensão sugerida para esta imagem é 600x300 pixels e o tamanho máximo é de 2mb.";
      return "A dimensão sugerida para esta imagem é 1080 x 1920 pixels e o tamanho máximo é de 2mb.";
    },
  },
  watch: {
    "$produtos_gerenciar.cadastro.customizacao.imagens_array"(e) {
      if (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME"
      ) {
        e.forEach(obj => {
          const variacaoesFilter = this.tipo_imagem_iframe.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.tipo_imagem_iframe.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.tipo_imagem_iframe[index].show = false;
              }
            });
          }
        });
      }
      if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
        e.forEach(obj => {
          const variacoesFilter = this.tipo_imagem_link.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacoesFilter) {
            this.tipo_imagem_link.map((item, index) => {
              if (variacoesFilter.value == item.value) {
                this.tipo_imagem_link[index].show = false;
              }
            });
          }
        });
      } else {
        e.forEach(obj => {
          const variacaoesFilter = this.tipo_imagem.find(
            o => Object.keys(obj)[0] === o.value
          );
          if (variacaoesFilter) {
            this.tipo_imagem.map((item, index) => {
              if (variacaoesFilter.value == item.value) {
                this.tipo_imagem[index].show = false;
              }
            });
          }
        });
      }
    },
    "$produtos_gerenciar.cadastro.customizacao.imagem_upload.object"(e) {
      if (e) {
        this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload = [];
      }
    },
  },
  mounted() {
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "IFRAME") {
      this.tipo_imagem_iframe.forEach((obj, index) => {
        const variacaoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacaoesFilter) {
          this.tipo_imagem_iframe[index].show = false;
        }
      });
    }
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "LINK") {
      this.tipo_imagem_link.forEach((obj, index) => {
        const variacoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacoesFilter) {
          this.tipo_imagem_link[index].show = false;
        }
      });
    } else {
      this.tipo_imagem.forEach((obj, index) => {
        const variacaoesFilter =
          this.$produtos_gerenciar.cadastro.customizacao.imagens_array.find(
            o => Object.keys(o)[0] === obj.value
          );
        if (variacaoesFilter) {
          this.tipo_imagem[index].show = false;
        }
      });
    }
    this.$produtos_gerenciar.cadastro.customizacao.error.imagem_upload = [];
  },
};
</script>

<style scoped>
.produtos-customizacao {
  width: 100%;
  margin: 20px 0px 40px 0px;
}

.produtos-add-edit-header-dados-cadastrais {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
}

.divider-title {
  margin-bottom: 30px;
}

.produtos-add-edit-container1 {
  width: 100%;
  /* max-width: 1200px; */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.input-file-tema {
  border-radius: 10px;
  width: 100%;
}

.imagens-table {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #fff;
}

.produtos-gerenciar-button {
  color: var(--dl-color-gray-white) !important;
  width: 94%;
  height: 51px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 10px;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button1 {
  color: var(--dl-color-gray-white) !important;
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-button3 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.produtos-gerenciar-icon {
  fill: var(--dl-color-gray-white) !important;
  width: 1.5rem;
  height: 1.5rem;
}
</style>
